package com.zaurh.mapquizwebsite.data.service

import com.zaurh.mapquizwebsite.domain.model.request.SignInRequest
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.contentType

class AuthApi(private val client: HttpClient) {
    suspend fun signIn(request: SignInRequest): HttpResponse {
        return client.post("sign-in-web") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
    }
}